import { render, staticRenderFns } from "./DealStatus.vue?vue&type=template&id=0625c050&scoped=true&"
import script from "./DealStatus.vue?vue&type=script&lang=js&"
export * from "./DealStatus.vue?vue&type=script&lang=js&"
import style0 from "./DealStatus.vue?vue&type=style&index=0&id=0625c050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0625c050",
  null
  
)

export default component.exports